module.exports = __webpack_public_path__ + "static/media/Fig-6-10_Rev.94c5f4db.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/content/media/Fig-6-10_Rev.mp4
// module id = 785
// module chunks = 0